// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.MyProfileToolbarActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { withHandlers } from 'recompose';
import UiState from 'logic/Izenda.UiState';
import CommonMessages from 'share/messages/Izenda.CommonMessages';
import { isNil, isEmpty } from 'lodash/fp';

/**
 * Save my profile
 * @param {Object} props
 */

const onSave = (props: any) => {
  return () => {
    const { loader, localization, validation, store: { model, model: { isDirty } } } = props;

    validation
      .validate()
      .then(success => {
        if (success) {
          loader.startLoading();

          if (isDirty) {
            return handleSave(props);
          } else {
            model.alertMessage = {
              type: CommonMessages.MESSAGE_TYPE.INFO,
              message: localization.getText('COMMON_MESSAGES_NO_CHANGES_FOUND')
            };
          }
        }
      })
      .finally(loader.endLoading.bind(loader));
  };
};

/**
 * @param {Object} props
 */
const handleSave = (props: any) => {
  const { localization, validation, store, store: { model } } = props;
  return props
    .confirmFn('Confirmation', {
      description: localization.getText('COMMON_MESSAGES_CONFIRM_SAVE')
    })
    .then(() => {
      return store.save().then(result => {
        if (!isNil(result.messages)) {
          isEmpty(result.messages[0].key)
            ? (model.alertMessage = {
                type: 'info',
                message: result.messages[0].messages[0]
              })
            : validation.updateErrors(result.messages);
        } else {
          model.alertMessage = {
            type: CommonMessages.MESSAGE_TYPE.SUCCESS,
            message: localization.getText('COMMON_MESSAGES_DETAILS_WERE_SAVED')
          };
        }

        result.hasChangeLanguage &&
          props.confirmMessage(
            'info',
            localization.getText('USER_MESSAGE_CHANGE_LANGUAGE')
          );
        return result;
      });
    });
};

/**
 * Cancel
 * @param {Object} props
 */
const onCancel = (props: any) => {
  return () => {
    const { localization, store: { model, model: { isDirty } } } = props;
    if (isDirty) {
      props.confirmFn('Confirmation', {
        description: localization.getText('COMMON_MESSAGES_CONFIRM_CANCEL')
      })
        .then(() => {
          model.reset(UiState.currentUser);
          model.resetDirty();
        });
    } else {
      model.alertMessage = {
        type: CommonMessages.MESSAGE_TYPE.INFO,
        message: localization.getText('COMMON_MESSAGES_NO_CHANGES_FOUND')
      };
    }
  };
};

export default withHandlers({
  onSave: onSave,
  onCancel: onCancel
});



// WEBPACK FOOTER //
// ./ui/modules/MyProfile/Toolbar/Izenda.MyProfileToolbarActions.js